import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";

/** DBCO-0062 - the sequence statuses the page has labels for (the execution ones arrive with DBCO-0042 / 0045). */
export const SEQUENCE_STATUSES: readonly string[] = [
  "PENDING_INFORMATION",
  "UPCOMING",
  "ONGOING",
  "COMPLETE",
];

/**
 * DBCO-0062 - the label of a sequence status, as the server returned it: a known name is translated, an unknown one
 * shows its raw value (the server may add a status before this list does), a missing one shows a dash.
 */
export const sequenceStatusLabel = (
  t: (key: string) => string,
  status: string | null | undefined,
): string => {
  if (status === null || status === undefined) {
    return "-";
  }
  return SEQUENCE_STATUSES.includes(status)
    ? t(`${DRYBULK_CARGO_OPS_LANG_BASE}.sequences.status.${status}`)
    : status;
};
